var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cssload-whirlpool"},[_c('b',{staticClass:"c0"}),_c('b',{staticClass:"c1"}),_c('b',{staticClass:"c2"})])}]

export { render, staticRenderFns }